import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  educationTypes: [],
  educationType: {},
  educationTypesAll: [],
});

export const mutations = {
  SET_EDUCATION_TYPES(state, payload) {
    state.educationTypes = vm.$toArray(payload);
  },

  SET_EDUCATION_TYPES_ALL(state, payload) {
    state.educationTypesAll = vm.$toArray(payload);
  },

  SET_EDUCATION_TYPE_BY_ID(state, payload) {
    state.educationType = payload || {};
  },
};

export const actions = {
  async INIT_EDUCATION_TYPES({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const data = await vm.$axios.$get(`admin/education-type${query}`);
    if (data) {
      commit("SET_EDUCATION_TYPES", data.content);

      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async EDUCATION_TYPE_BY_ID({ commit }, { id }) {
    let status = false;

    try {
      const data = await vm.$axios.$get(`admin/education-type/${id}`);
      if (Array.isArray(data)) {
        commit("SET_EDUCATION_TYPE_BY_ID", data);

        status = true;
      }
    } catch (error) {
      //
    }

    return status;
  },

  async ADD_EDUCATION_TYPE(ctx, educationType) {
    let status = false;
    const url = "admin/education-type";
    const method = educationType.id ? "$post" : "$put";

    status = await vm.$axios[method](url, educationType);

    return status;
  },

  async EDUCATION_TYPE_STATUS(ctx, { id, active }) {
    let status = false;

    const url = `admin/education-type/${id}/`;
    const method = !active ? "deactivation" : "activation";

    status = await vm.$axios.$post(url + method);

    return status;
  },

  async INIT_EDUCATION_TYPES_ALL({ commit }) {
    const data = await vm.$axios.$get(`admin/education-type/all`);
    if (data) {
      commit("SET_EDUCATION_TYPES_ALL", data);
    }
  },
};

export const getters = {
  GET_EDUCATION_TYPES: (state) => state.educationTypes,
  GET_EDUCATION_TYPE_BY_ID: (state) => state.educationType,
  GET_EDUCATION_TYPES_ALL: (state) => state.educationTypesAll,
};
